import { ReplicantMigrator } from '@play-co/replicant';

// IMPORTANT: Do *NOT* import anything.

const migrator = new ReplicantMigrator();

// Add migrations right above this line. Do *NOT* modify existing migrations.

/**
 * Remove gems it should be replaced by `premium` currency
 * Added default value for points
 */
migrator.addMigration(1, (state) => {
  // Remove gems it should be replaced by `premium` currency
  // Premium currency will be represented by: { free: number, paid: number }
  if (state?.inventory?.gems) {
    // If no state for premium currency let's add it
    if (state && state.premium === undefined) {
      state.inventory.premium = { free: 0, paid: 0 };
    }

    // Move gems to premium.free
    state.inventory.premium.free = state.inventory.gems;
  }
});

/**
 * Change `receiveMessages` type from boolean to string.
 */
migrator.addMigration(2, (state) => {
  if (!state.settings) return;
  state.settings.receiveMessages = state.settings.receiveMessages
    ? 'on'
    : 'off';
});

/**
 * Sync unlocked species with encyclopedia.
 */
migrator.addMigration(3, (state) => {
  if (!state.pet?.evolutions) return;

  if (!state.encyclopedia) {
    state.encyclopedia = {
      speciesState: {},
    };
  }

  state.pet.evolutions.forEach(({ species }) => {
    state.encyclopedia.speciesState[species] = 'unlocked';
  });
});

export default migrator;
